import { z } from 'zod';

/**
 * Admin media library (ADR-004 / ADR-008). Unlike chat attachments
 * (packages/contracts/src/chat.ts), this media is owner-uploaded public site
 * content (hero images, etc.) — `url` is a same-origin API path
 * (`/api/v1/media/:id/raw`), not necessarily an absolute URL, so it's a
 * plain string here rather than `.url()`.
 */
export const MediaSchema = z.object({
  id: z.string().cuid(),
  url: z.string().min(1),
  mimeType: z.string(),
  bytes: z.number().int().nonnegative(),
  width: z.number().int().nonnegative().nullable(),
  height: z.number().int().nonnegative().nullable(),
  altText: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type Media = z.infer<typeof MediaSchema>;

export const MediaListQuerySchema = z.object({
  cursor: z.string().cuid().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type MediaListQuery = z.infer<typeof MediaListQuerySchema>;

export const MediaListResponseSchema = z.object({
  media: z.array(MediaSchema),
  hasMore: z.boolean(),
});
export type MediaListResponse = z.infer<typeof MediaListResponseSchema>;
